<script setup>
import "rangeslider.js";

import { onMounted } from "vue";
onMounted(() => {
  require('@/assets/js/elss.js')
});
</script>
<template>
  <main class="seo-calculators">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a href="/calculator/">
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>ELSS Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading">ELSS Calculator</h1>
      <h2 class="page-sub-heading">Calculate your Mutual Fund SIP returns.</h2>

      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="selection form-elss">
                  <label class="radio-button"
                    >Sip
                    <input type="radio" checked="" name="type" value="sip" />
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio-button"
                    >Lumpsum
                    <input type="radio" name="type" value="lumpsum" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">
                      <span id="investment-slider-title"
                        >Amount of Investment</span
                      >
                    </h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="totalInvestments"
                        value="25000"
                        min="1000"
                        max="10000000"
                        step="500"
                        id="total-investment-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="1000"
                    value="25000"
                    max="10000000"
                    id="total-investment-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">₹1000</div>
                    <div class="slider__max">₹10,000,000</div>
                  </div>
                </div>

                <div class="slider selection frequency-data">
                  <h3 class="slider__heading">Frequency of SIP</h3>
                  <div class="frequency-data-wrap">
                    <label class="radio-button">
                      <input
                        type="radio"
                        checked=""
                        name="frequency"
                        value="12"
                      />
                      <span class="checkmark"></span>Monthly
                    </label>
                    <label class="radio-button">
                      <input type="radio" name="frequency" value="26.0893" />
                      <span class="checkmark"></span>Fortnightly
                    </label>
                    <label class="radio-button">
                      <input type="radio" name="frequency" value="4" />
                      <span class="checkmark"></span>Quarterly
                    </label>
                  </div>
                </div>

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Expected Rate of Return P.A</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="returnRate"
                        value="12"
                        step="0.1"
                        min="0"
                        max="40"
                        id="return-rate-input"
                      /><span>%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="0"
                    value="12"
                    step="0.1"
                    max="40"
                    id="return-rate-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 %</div>
                    <div class="slider__max">40%</div>
                  </div>
                </div>

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Duration of Investment</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="timePeriod"
                        value="10"
                        step="0.1"
                        min="0"
                        max="30"
                        id="period-input"
                      /><span class="m-l-4">Yrs</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="10"
                    step="0.1"
                    min="0"
                    max="30"
                    id="period-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 yr</div>
                    <div class="slider__max">30 yrs</div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding">
            <aside class="calculator-output">
              <h3 class="calculator-output__heading">
                The total value of your investment will be
              </h3>
              <div
                id="total-investment"
                class="calculator-output__amount--large"
              >
                ₹ 58,08,477
              </div>

              <div class="calculator-output__row">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Invested Amount</h3>
                  <div
                    id="invested-amount"
                    class="calculator-output__amount--small"
                  >
                    ₹ 30,00,000
                  </div>
                </div>
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Est. Returns</h3>
                  <div id="est-amount" class="calculator-output__amount--small">
                    ₹ 28,08,477
                  </div>
                </div>
              </div>
              <div class="calculator-output__chart-container">
                <canvas
                  id="mfChart"
                  width="200"
                  height="200"
                  style="
                    display: block;
                    box-sizing: border-box;
                    height: 200px;
                    width: 200px;
                  "
                ></canvas>
                <div class="calculator-output__chart-container--legend">
                  <div class="legend-title">
                    <span class="purple"></span>
                    <h3>Invested Amount</h3>
                  </div>
                  <div class="legend-title">
                    <span class="gold"></span>
                    <h3>Estimated Returns</h3>
                  </div>
                </div>
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is an ELSS?</h2>
      <p></p>
      <p>
        An equity-linked savings scheme (ELSS) is an open-ended equity mutual
        fund offering tax benefits up to ₹1,50,000, under Section 80C of the
        Income Tax Act, 1961. By investing in ELSS, you can save some amount
        every year in taxes and promote the habit of long-term investment and
        saving. These funds invest the majority of their assets in diversified
        equity and equity-related instruments across various sectors. In
        addition to equity and debt securities, ELSS funds also invest in
        fixed-income securities. Thus, investors can gain exposure to a
        diversified portfolio by investing in ELSS. These funds have a short
        lock-in period, which allows you to withdraw your funds at an earlier
        time, if any pressing financial goals arise. ELSS funds invest largely
        in the stock market, so they can potentially earn higher yields than
        other traditional tax-saving options. However, like all stock market
        investments, returns are not guaranteed and are subject to market risks.
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section" id="calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse1">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is an ELSS calculator?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  The ELSS calculator helps investors determine the potential
                  returns from a potential investment in an ELSS fund based on
                  the type of investment, i.e. SIP or lump sum.
                </p>
                <p>
                  The ELSS calculator needs the following details to calculate
                  the returns:
                </p>
                <p>
                  ● Investment type<br />
                  ● Investment value<br />
                  ● Duration of investment (more than or equal to 3 years)<br />
                  ● Rate of return (per annum)
                </p>
                <p>
                  Once you enter the above-mentioned details, the Upstox ELSS
                  calculator will display the value of your investment at the
                  end of the investment tenure. The Upstox ELSS calculator can
                  help you estimate the additional amount to be invested if you
                  wish to reach your goals sooner. It can also be used to
                  calculate SIP returns.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse2">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are the benefits of investing in ELSS?</span>
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Investing in an ELSS fund offers two benefits: capital
                  appreciation and tax savings of up to ₹1,50,000 under Section
                  80C of the Income Tax Act.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse3">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is the lock-in period of ELSS?</span>
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  The lock-in period for ELSS funds is three years. Investors
                  can withdraw their money any time after the three-year period
                  has elapsed. They also have the option of continuing to invest
                  in the fund.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse4">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What are the tax implications of investing in ELSS?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Under section 80C of the Income Tax Act, investments in ELSS
                  funds are eligible for a tax exemption of up to ₹1,50,000. As
                  ELSS funds are open-ended equity funds, they are taxed in the
                  same way as equity funds. There are no short-term financial
                  gains with ELSS because they have a three-year lock-in period.
                  They are, however, liable to a 10% long-term capital gains tax
                  on gains exceeding ₹1,00,000.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse5">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How can I invest in an ELSS?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  SIP and lump sum investments are both options for ELSS funds.
                  Since ELSS funds are equity-based, the SIP approach is
                  preferable due to its advantages. ELSS funds can be purchased
                  online through the Upstox platform or the fund house’s
                  website. Offline investing is also possible by visiting the
                  fund house’s nearest branch.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse6">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Who should invest in ELSS?</span>
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  The ELSS fund is designed for investors who want to save taxes
                  while investing in equities and gaining exposure. These funds
                  are also aimed at investors looking for a variety of
                  investments in mutual funds. ELSS, like any other tax-saving
                  option, is not an option for investors seeking fixed returns.
                  As ELSS invests in equity, the returns are market-tied and
                  fluctuating.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse7">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What is the amount that someone can invest in a financial
                    year?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse7" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  There is no upper limit to the amount you can invest in a
                  financial year. Based on your budget and financial goals, you
                  can invest as much as you want. However, tax savings are
                  available for ELSS investments up to ₹1,50,000 every year.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse8">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Are ELSS funds risky?</span>
                </span>
              </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  As the name suggests, ELSS funds invest in equities and like
                  every other market-linked mutual fund, these funds are subject
                  to the market risks too. However, you will be able mitigate
                  this risk by contributing to the fund with a long-term
                  approach.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" href="#collapse9">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is the best time to invest in ELSS?</span>
                </span>
              </h3>
            </div>
            <div id="collapse9" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Most of the investors invest in ELSS towards the end of the
                  financial year to save tax, which might not be the best
                  strategy. Tax saving is an essential consideration for
                  investing in these funds, but it must not be the primary
                  reason. The best way to maximise returns from these funds is
                  to invest with a long-term approach. Therefore, identify your
                  investment goals at the beginning of the year and invest
                  accordingly through SIPs. Investing regularly throughout the
                  year can reduce your exposure to market volatility and build
                  wealth over a period of time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/brokerage-calculator/">
                Brokerage Calculator</a
              >
            </h3>
          </div>

          <!-- <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/span-calculator/">
                Margin Calculator</a
              >
            </h3>
          </div> -->

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/mutual-fund-return/">
                Mutual Fund Returns Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/sip-calculator/">
                SIP Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/npv/"> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/future-value/">
                Future Value Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/swp/"> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/option-value/">
                Option Value Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/nps/"> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                href="/calculator/ppf-public-provident-fund/"
              >
                PPF Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                href="/calculator/cagr-calculate-compound-annual-growth-rate/"
              >
                Compound Annual Growth Rate Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                href="/calculator/nsc-national-savings-certificate/"
              >
                National Savings Certificate Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/sukanya-samriddhi-yojana/">
                Sukanya Samriddhi Yojana Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/compound-interest/">
                Compound Interest Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/atal-pension-yojana-apy/">
                Atal Pension Yojana Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/gratuity/">
                Gratuity calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/simple-interest/">
                Simple Interest Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/fd-fixed-deposit/">
                Fixed Deposit Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a href="/calculator/gst/"> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                href="/calculator/hra-house-rent-allowance-calculator/"
              >
                HRA Calculator</a
              >
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style lang="scss" src="@/styles/css/seo-calculators.scss"></style>
<style scoped lang="scss">
@import 'rangeslider.js/dist/rangeslider.css';
</style>
